var map = {
	"./avatars/avatar": 31,
	"./avatars/avatar-3": 32,
	"./avatars/avatar-3.png": 32,
	"./avatars/avatar.jpg": 31,
	"./errors-images/404-error": 33,
	"./errors-images/404-error.png": 33,
	"./errors-images/505-error": 34,
	"./errors-images/505-error.png": 34,
	"./lexiqamus-logo": 35,
	"./lexiqamus-logo.png": 35,
	"./lexiqamus-sidebar-logo": 36,
	"./lexiqamus-sidebar-logo.png": 36,
	"./lexiqamus/innovation_announcements/hareket1": 16,
	"./lexiqamus/innovation_announcements/hareket1.jpg": 16,
	"./lexiqamus/innovation_announcements/hareket2": 17,
	"./lexiqamus/innovation_announcements/hareket2.jpg": 17,
	"./lexiqamus/innovation_announcements/hareket3": 18,
	"./lexiqamus/innovation_announcements/hareket3.jpg": 18,
	"./lexiqamus/innovation_announcements/hareket4": 19,
	"./lexiqamus/innovation_announcements/hareket4.jpg": 19,
	"./lexiqamus/innovation_announcements/original-document": 20,
	"./lexiqamus/innovation_announcements/original-document.png": 20,
	"./lexiqamus/innovation_announcements/smart-results": 21,
	"./lexiqamus/innovation_announcements/smart-results.png": 21,
	"./lexiqamus/landing/hareket1": 37,
	"./lexiqamus/landing/hareket1.jpg": 37,
	"./lexiqamus/landing/hareket2": 38,
	"./lexiqamus/landing/hareket2.jpg": 38,
	"./lexiqamus/landing/hareket3": 39,
	"./lexiqamus/landing/hareket3.jpg": 39,
	"./lexiqamus/landing/hareket4": 40,
	"./lexiqamus/landing/hareket4.jpg": 40,
	"./lexiqamus/landing/original-document": 41,
	"./lexiqamus/landing/original-document.png": 41,
	"./lexiqamus/landing/smart-results": 42,
	"./lexiqamus/landing/smart-results.png": 42,
	"./logo-icon": 43,
	"./logo-icon.png": 43,
	"./lq-logo": 44,
	"./lq-logo.png": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;